import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { CITY_TOWER_PAGE_PATH } from "utils/constants/paths";

const CityTowerPage = Loadable(React.lazy(() => import("./View")));

export const CityTowerPageRoute: IRouteItem = {
  path: CITY_TOWER_PAGE_PATH,
  element: React.createElement(CityTowerPage),
  name: "City Tower",
};
